import { DEFAULT_VCN_MANAGEMENT_FILTERS } from './vcnManagementFilterDefaults'
import type { GetVcnManagementListRequestDto } from '../../api/dto/vcn-management-list.dto'
import type { VcnManagementBenefitFilters } from './types'

export function toVcnManagementBenefitListRequest(
  filters: VcnManagementBenefitFilters,
  page: number,
  pageSize: number
): GetVcnManagementListRequestDto {
  return {
    ...filters,
    page,
    pageSize,
  }
}

export function countVcnManagementBenefitActiveFilters(
  filters: VcnManagementBenefitFilters
): number {
  const {
    search,
    clientPublicKeys,
    carrierName,
    vcnProvider,
    vcnStatus,
    primaryPaymentMethod,
  } = filters
  const { vcnStatus: defaultStatus } = DEFAULT_VCN_MANAGEMENT_FILTERS
  const activeChecks: boolean[] = [
    Boolean(search),
    (clientPublicKeys?.length ?? 0) > 0,
    Boolean(carrierName),
    Boolean(vcnProvider),
    Boolean(vcnStatus) && vcnStatus !== defaultStatus,
    Boolean(primaryPaymentMethod),
  ]
  return activeChecks.filter(Boolean).length
}
